import { useEffect, useState, useMemo } from 'react';
import moment from 'moment-timezone';
import { BackendDateFormat } from 'utils/constants';

interface TimeSlot {
  date: string; // Format: 'YYYY-MM-DD'
  time: string; // Format: 'hh:mm A'
  dateTimeOffset: string; // Format: 'YYYY-MM-DD HH:mm:ss Z'
  slotEndTime: string;
  appointments:any
}

interface Appointment {
  appointment_end_time:string;
  appointment_time: string; // Format: 'YYYY-MM-DD HH:mm:ss Z'
}

const useTimeSlots = (
  Schedules:any[] = [],
  delayInMinutes: number,
  participant: number,
  startDateTime:string,
  skipHours:number,
): TimeSlot[] => {
  const [timeSlots, setTimeSlots] = useState<TimeSlot[]>([]);

  const memoizedSchedules = useMemo(() => Schedules, [JSON.stringify(Schedules)]);
  const startDateTimeMoment = moment.parseZone(startDateTime, BackendDateFormat);
  const adjustedStartDate = startDateTimeMoment.clone().add(skipHours, 'hours');
 

  const generateTimeSlots = useMemo(() => {
    const slots: TimeSlot[] = [];
    memoizedSchedules.forEach(schedule => {
      const start = moment.parseZone(schedule.checkin_time, BackendDateFormat);
      const end = moment.parseZone(schedule.checkout_time, BackendDateFormat);
      let current = start.clone();

      while (current.isBefore(end)) {
        const date = current.format('YYYY-MM-DD'); // Extract date part in 'YYYY-MM-DD' format
        const time = current.format('hh:mm A'); // Format time to 'hh:mm A'
        const dateTimeOffset = current.format('YYYY-MM-DD HH:mm:ss Z'); // Format datetime with offset
        const slotEndTime = current.clone().add(delayInMinutes, 'minutes').format('YYYY-MM-DD HH:mm:ss Z');
        const appointments = schedule?.appointments;
        slots.push({ date, time, dateTimeOffset,slotEndTime,appointments });
        current.add(delayInMinutes, 'minutes'); // Move to the next slot by adding the delay
      }
    });

    slots.sort((a, b) => moment(a.dateTimeOffset).diff(moment(b.dateTimeOffset)));
    //remove duplicate times from list
    const uniqueSlots = slots.filter((slot, index, self) => {
      return self.findIndex(s => s.dateTimeOffset === slot.dateTimeOffset) === index;
    });

    return uniqueSlots;
  }, [memoizedSchedules,delayInMinutes]);

  useEffect(() => {
    const filteredSlots = generateTimeSlots.filter(slot => {
      const slotTimeStart = moment(slot.dateTimeOffset);
      const slotTimeEnd = moment(slot.slotEndTime);
      if (slotTimeStart.isBefore(adjustedStartDate)) {
        return false;
      }
      const overlappingAppointments = slot.appointments.filter((appointment: { appointment_time: moment.MomentInput; appointment_end_time: moment.MomentInput; }) => {
        const appointmentTimeStart = moment(appointment.appointment_time);
        const appointmentTimeEnd = moment(appointment.appointment_end_time);
        return(
          (appointmentTimeStart.isSame(slotTimeStart)
          //  && appointmentTimeStart.isSameOrBefore(startDateTimeMoment)
          // ||(appointmentTimeStart.isSameOrBefore(slotTimeStart) && appointmentTimeEnd.isAfter(slotTimeStart)) ||
          //   (slotTimeStart.isSameOrBefore(appointmentTimeStart) && slotTimeEnd.isAfter(appointmentTimeStart))
          )
        );
      });
      return overlappingAppointments.length < participant;
    });

    setTimeSlots(filteredSlots);
  }, [generateTimeSlots, participant,startDateTime,skipHours]);

  return timeSlots;
};

export default useTimeSlots;
